import { createFileRoute } from '@tanstack/react-router';
import { SettingsPage } from '@/page/SettingsPage';

export const Route = createFileRoute('/_app/settings/')({
  component: () => <SettingsPage tab="profile" />,
});
